export enum LocalStorageKeyEnum {
  UserAuth = 'USER_AUTH',
  AdminAccessToken = 'AdminAccessToken',
  Username = 'username',
  Password = 'password'
}
